import { Fab } from '@mui/material';
import { Add } from '@mui/icons-material';
import useStyles from './styles';

interface AddButtonProps {
  label: string;
  onClick?: (args?: unknown) => void;
}

export function AddButton({ label, onClick }: AddButtonProps) {
  const classes = useStyles();

  return (
    <div className={classes.addContainer} onClick={onClick}>
      {label}
      <Fab color="primary" aria-label="add" className={classes.fab} disableRipple disableFocusRipple>
        <Add />
      </Fab>
    </div>
  );
}

export default AddButton;
